import '../../../resources/css/admin_style.css';
import styles from './component.module.css';
import { useState, useEffect, useContext } from 'react';
import EditModal from './modal/EditModal';
import { IAM_SERVER_UNIFIEDPROFILE } from '../../../utils/Config';
import axios from "../../../utils/api/axios";
import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import { getCookie } from '../../../utils/cookies/cookies';
import {AuthContext} from "../../../utils/contextapi/AuthProvider";


function InfoItem({ label, value, onClick }) {
  return (
    <div className={styles.infoItem} onClick={onClick}>
      <span className={styles.infoItemLabel}>{label}</span>
      <span className={`${styles.infoItemValue} ${styles.noArrow}`}>
        {value || ""} 
      </span>
    </div>
  );
}

function AccountInfoPanel({ user, onUserUpdate  }) {
  const [showModal, setShowModal] = useState(false);
  const [editField, setEditField] = useState("");
  const [inputValue, setInputValue] = useState("");

  const {saveUser} = useContext(AuthContext);

  const handleEdit = (field) => {
    // setEditField(field);
    // setInputValue(user?.[field] || "");
    // setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditField("");
    setInputValue("");
  };


  const saveChange = () => {
    // TODO: API 호출 또는 상태 저장 처리

    const userId = getCookie("user_id");
    // 기존 정보에 기반해 수정
    const params = {
      unifiedProfileId: userId,
      name: user.name,
      birth: user.birthdate,
      gender: user.gender,
    };


    // 수정된 값 반영
    if (editField === "name") {
      params.name = inputValue;
    } else if (editField === "birthdate" || editField === "birth") {
      params.birth = inputValue;
    } else if (editField === "gender") {
      params.gender = inputValue;
    }

    const url = IAM_SERVER_UNIFIEDPROFILE + "/update";
    axios.post(url, params)
      .then((res) => {
        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);

        const updatedUser = { ...user, [editField]: inputValue };
        saveUser(updatedUser);
        if (typeof onUserUpdate === "function") {
          onUserUpdate(true);
        }

      })
      .catch((e) => {
        showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
        closeModal();
      })



  };


    function formatBirthdate(raw) {
      if (!raw) return null;

      // 1. 하이픈 있는 경우: "2025-04-02"
      if (raw.includes("-")) {
        const [yyyy, mm, dd] = raw.split("-");
        return `${yyyy}년 ${parseInt(mm, 10)}월 ${parseInt(dd, 10)}일`;
      }

      // 2. 하이픈 없는 경우: "20250402"
      if (raw.length === 8) {
        const yyyy = raw.substring(0, 4);
        const mm = raw.substring(4, 6);
        const dd = raw.substring(6, 8);
        return `${yyyy}년 ${parseInt(mm, 10)}월 ${parseInt(dd, 10)}일`;
      }

      // 3. 기타: 그대로 반환
      return raw;
    }
    

  const labelMap = {
    name: "이름",
    birthdate: "생년월일",
    gender: "성별"
  };

  const fieldTypes = {
    name: "text",
    birthdate: "date",
    gender: "radio"
  };

  const fieldOptions = {
    gender: [
      { label: "남성", value: "man" },
      { label: "여성", value: "woman" }
    ]
  };

  return (
    <div className={styles.infoCard}>
      <h2 className={styles.infoTitle}>기본 정보</h2>
      <div className={styles.profileList}> 
          <InfoItem
            label={labelMap.name}
            value={user.gender === null ? '본인인증 미확인' : user?.name}
            onClick={() => handleEdit("name")}
          />
          <InfoItem
            label={labelMap.birthdate}
            value={user.gender === null ? '본인인증 미확인' : (formatBirthdate(user?.birthdate))}
            onClick={() => handleEdit("birthdate")}
          />
          <InfoItem
            label={labelMap.gender}
            value={user.gender === null ? '본인인증 미확인' : (user?.gender === "man" ? "남성" : "여성")}
            onClick={() => handleEdit("gender")}
          />
    </div>
      {showModal && (
        <EditModal
          title={labelMap[editField]}
          type={fieldTypes[editField]}
          value={inputValue}
          onChange={setInputValue}
          onClose={closeModal}
          onSave={saveChange}
          options={fieldOptions[editField]}
        />
      )}
    </div>
  );
}

export default AccountInfoPanel;
